import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	share: {
		id: 'business-issue-field-statistics.statistics-sidebar.share-button.share-non-final',
		defaultMessage: 'Share this chart',
		description:
			'Indicates that clicking the button will allow sharing the chart, via copying the url to clipboard',
	},
	errorFlagTitle: {
		id: 'business-issue-field-statistics.error-flag-title-non-final',
		defaultMessage: 'Something went wrong',
		description:
			'Title of the flag displayed when an unexpected error is caught by the error boundary.',
	},
	errorFlagDescription: {
		id: 'business-issue-field-statistics.error-flag-description-non-final',
		defaultMessage:
			'We were unable to copy the link to clipboard. Please try again or contact support.',
		description:
			'Title of the flag displayed when an unexpected error is caught by the error boundary.',
	},
	errorFlagContactSupportActionText: {
		id: 'business-issue-field-statistics.error-flag-contact-support-action-text-non-final',
		defaultMessage: 'Contact support',
		description:
			'The text of the link displayed in the flag for the user to click on to open the contact support page.',
	},
	linkCopiedPopup: {
		id: 'business-issue-field-statistics.statistics-sidebar.share-button.link-copied-popup',
		defaultMessage: 'Link copied to clipboard',
		description:
			'The pop up message displayed when the link is successfully copied to the clipboard.',
	},
});
